module.exports = __webpack_public_path__ + "img/facility-2.cffeaf6d.png";